export const PlayerRestrictionsEnum = {
  FULL_LOCK_ACCOUNT: 'Full Account Lock',
  BET_BLOCK: 'Bet Block',
} as const;
